<template>
  <div class="grid grid-cols-3 md:grid-cols-5 gap-16 py-16 mb-32" role="group" aria-label="Job Responsibilities">
    <div v-for="(item, index) in responsibilitiesOptions" :key="index">
      <Requirement v-model:requirements-selections="selectedResponsibilities" :value="item.value" :aria-label="item.textLabel">
        <template #graphic>
          <component :is="item.icon" role="img" :aria-label="item.textLabel" />
        </template>
        {{ item.textLabel }}
      </Requirement>
    </div>
  </div>
</template>

<script lang="ts">
import Requirement from './RequirementsToken.vue';
import { Responsibilities } from '@/store/modules/job/types';
import { ResponsibilityOption, responsibilityOptions } from './types/responsibilitiesOptions';

export default {
  name: 'ResponsibilitiesSection',
  components: {
    Requirement,
  },
  props: {
    responsibilities: {
      type: Array as () => Responsibilities[],
      default: () => [],
    },
  },
  data() {
    return {
      hideModal: true,
    };
  },
  computed: {
    responsibilitiesOptions(): ResponsibilityOption[] {
      return responsibilityOptions;
    },
    selectedResponsibilities: {
      get(): Responsibilities[] {
        return this.responsibilities;
      },
      set(newValue: Responsibilities[]) {
        this.$emit('update:responsibilities', newValue);
      },
    },
  },
};
</script>
